import Flicking from "./Flicking";
import { useFlickingReactiveAPI } from "./reactive";

Flicking.useFlickingReactiveAPI = useFlickingReactiveAPI;
export default Flicking;
